import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SortConfig, SortDirection } from "types/common";
import { ClinicType } from "types/Clinic";
import { Clinician } from "types/Clinician";

export interface ClinicState {
  clinicList: ClinicType[];
  atheletesList: string[];
  clinicUserList: Clinician[];
  sortConfig: SortConfig;
  loading: boolean;
  offset: number;
  limit: number;
  total: number;
}

const initialState: ClinicState = {
  clinicList: [],
  atheletesList: [],
  clinicUserList: [],
  loading: false,
  offset: 0,
  limit: 15,
  total: 0,
  sortConfig: {
    sortBy: "name",
    sortDirection: SortDirection.asc,
  },
};

export const clinicSlice = createSlice({
  name: "Clinic",
  initialState,
  reducers: {
    resetPagination: (state) => {
      state.offset = initialState.offset;
      state.limit = initialState.limit;
      state.loading = initialState.loading;
      state.total = initialState.total;
    },
    setClinicList: (state, { payload }: PayloadAction<ClinicType[]>) => {
      state.clinicList = payload;
    },
    setClinicUserList: (state, { payload }: PayloadAction<Clinician[]>) => {
      state.clinicUserList = payload;
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setOffset: (state, { payload }: PayloadAction<number>) => {
      state.offset = payload;
    },
    setLimit: (state, { payload }: PayloadAction<number>) => {
      state.limit = payload;
    },
    setTotal: (state, { payload }: PayloadAction<number>) => {
      state.total = payload;
    },
    setSortConfig: (state, { payload }: PayloadAction<SortConfig>) => {
      state.sortConfig = payload;
    },
  },
});

export const {
  setClinicList,
  setClinicUserList,
  setLoading,
  setSortConfig,
  setOffset,
  setLimit,
  setTotal,
  resetPagination,
} = clinicSlice.actions;
export const { reducer } = clinicSlice;
